import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import LogisticsImg1 from '../../assest/Planning.png';
import LogisticsImg2 from '../../assest/Logistics-2.png';
import LogisticsImg3 from '../../assest/Logistics-3.png';

const logisticsList = [
  {
    name: "Planning & Coordination",
    image: LogisticsImg1,
    specs: "Comprehensive project movement planning.",
    description: "Ensures timely and efficient allocation of resources, routes, and schedules across all stages of your project.",
  },
  {
    name: "On-Site Logistics Management",
    image: LogisticsImg2,
    specs: "Streamlining daily material and equipment flow.",
    description: "Dedicated support to manage deliveries, inventory, and site setup with precision.",
  },
  {
    name: "Supply Chain Support",
    image: LogisticsImg3,
    specs: "End-to-end tracking and vendor coordination.",
    description: "From procurement to delivery, we manage supplier communication and material availability.",
  },
];

const translations = {
  gb: {
    heading: "Project Logistics",
    introText: "Expert logistics services tailored for construction and development projects.",
    categoriesTitle: "Logistics Categories",
    featuredTitle: "Top Project Logistics Services",
    featuredDescription: "Optimize your project with our full-spectrum logistics solutions and planning expertise.",
  },
  sa: {
    heading: "لوجستيات المشروع",
    introText: "خدمات لوجستية احترافية مصممة خصيصًا لمشاريع البناء والتطوير.",
    categoriesTitle: "فئات الخدمات اللوجستية",
    featuredTitle: "أفضل خدمات لوجستيات المشاريع",
    featuredDescription: "حسّن مشروعك من خلال حلولنا الشاملة وخبرتنا في التخطيط اللوجستي.",
  },
};

const ProjectLogistics = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={logisticsList}
      language={language}
    />
  );
};

export default ProjectLogistics;
